export const apiPath = '/v2/custom_fields';
const actionType = 'CUSTOM_FIELDS';

export const bulkActionType = `${actionType}_BULK`;

export default actionType;
